/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  GetApiBillingCategoryList200,
  GetApiBillingCategoryListParams,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBillingCategoryListResponse200 = {
  data: GetApiBillingCategoryList200
  status: 200
}

export type getApiBillingCategoryListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBillingCategoryListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBillingCategoryListResponseSuccess = (getApiBillingCategoryListResponse200) & {
  headers: Headers;
};
export type getApiBillingCategoryListResponseError = (getApiBillingCategoryListResponse401 | getApiBillingCategoryListResponse403) & {
  headers: Headers;
};

export type getApiBillingCategoryListResponse = (getApiBillingCategoryListResponseSuccess | getApiBillingCategoryListResponseError)

export const getGetApiBillingCategoryListUrl = (params?: GetApiBillingCategoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/billing-categories/?${stringifiedParams}` : `/api/billing-categories/`
}

export const getApiBillingCategoryList = async (params?: GetApiBillingCategoryListParams, options?: RequestInit): Promise<getApiBillingCategoryListResponse> => {
  
  return customFetch<getApiBillingCategoryListResponse>(getGetApiBillingCategoryListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


